import { useEffect, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import { api, formatVnd, type Indust, type ShopCard } from '../lib/api'
import { plain } from './ContentPages'

export function DigitalShopPage() {
  const [products, setProducts] = useState<ShopCard[] | null>(null)
  const [industs, setIndusts] = useState<Indust[]>([])
  const [indust, setIndust] = useState<number | null>(null)
  const [q, setQ] = useState('')

  useEffect(() => {
    api
      .digitalShop()
      .then((r) => {
        setProducts(r.products)
        setIndusts(r.industs)
      })
      .catch(() => setProducts([]))
  }, [])

  const shown = useMemo(() => {
    const term = q.trim().toLowerCase()
    return (products || []).filter(
      (p) => (indust == null || p.indust_id === indust) && (!term || p.name.toLowerCase().includes(term)),
    )
  }, [products, indust, q])

  return (
    <div className="content-page">
      <section className="content-hero">
        <h1 className="page-title">
          <i className="fa-solid fa-laptop-code" aria-hidden /> Sản phẩm số
        </h1>
        <div className="content-search">
          <i className="fa-solid fa-magnifying-glass" aria-hidden />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Tìm sản phẩm…" />
        </div>
      </section>
      {industs.length ? (
        <div className="rp-versions">
          <button type="button" className={`rp-chip${indust == null ? ' active' : ''}`} onClick={() => setIndust(null)}>
            Tất cả
          </button>
          {industs.map((i) => (
            <button
              key={i.id}
              type="button"
              className={`rp-chip${indust === i.id ? ' active' : ''}`}
              onClick={() => setIndust(i.id)}
              title={i.name}
            >
              {i.name.split(' - ')[0]}
            </button>
          ))}
        </div>
      ) : null}
      {products === null ? <p className="muted">Đang tải…</p> : null}
      {products && !shown.length ? <p className="muted">Không có sản phẩm phù hợp.</p> : null}
      <div className="shop-grid">
        {shown.map((p) => (
          <Link key={p.id} className="shop-card" to={p.id === 14 ? '/mua-minecraft' : `/san-pham/${encodeURIComponent(p.slug)}`}>
            <div className="shop-media">
              {p.image_url ? <img src={p.image_url} alt="" loading="lazy" /> : <i className="fa-solid fa-box" aria-hidden />}
            </div>
            <h3>{p.name}</h3>
            {p.short_desc ? <p className="muted">{plain(p.short_desc, 90)}</p> : null}
            <p className="shop-price">
              <strong>{formatVnd(p.price_transfer)}</strong>
              {p.price > p.price_transfer ? <s className="muted">{formatVnd(p.price)}</s> : null}
            </p>
            <span className="shop-deliver">
              <i className={`fa-solid ${p.deliver === 'instant' ? 'fa-bolt' : 'fa-user-clock'}`} aria-hidden />{' '}
              {p.deliver === 'instant' ? 'Giao tự động' : 'Giao thủ công'}
            </span>
          </Link>
        ))}
      </div>
    </div>
  )
}
